import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import Stream from 'flarum/utils/Stream';

export default class UserPointsModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    // this.points = Stream(this.attrs.user.data.attributes['points'] || 0);
  }

  className() {
    return 'UserPointsModal Modal--small';
  }

  title() {
    return app.translator.trans('tf-points.forum.modal.title', {user: this.attrs.user});
  }

  content() {
    // const pointsName = app.forum.attribute('tf-points.pointsname') || '[points]';

    return (
      <div className="Modal-body">
        <div className="Form">
          <div className="Form-group">
            <label>{app.translator.trans('tf-points.forum.modal.current')} {pointsName.replace('[points]', this.attrs.user.data.attributes.points)}</label>
            <input required className="FormControl" type="number" step="1" bidi={this.points} />
          </div>
          <div className="Form-group">
            {Button.component(
              {
                className: 'Button Button--primary',
                type: 'submit',
                loading: this.loading,
              },
              app.translator.trans('tf-points.forum.modal.submit_button')
            )}
          </div>
        </div>
      </div>
    );
  }

  onsubmit(e) {
    e.preventDefault();

    this.loading = true;

    this.attrs.user
    .save({points: this.points()}, { errorHandler: this.onerror.bind(this) })
    .then(this.hide.bind(this))
    .catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
}